export const commit = '08a0792a7cf4fcacb81c9612cbdabeecf0807589';
export const branch = '25.05-beta.714';
export const date = '2025-04-29 18:30:58 MSK';
export const version = branch.match(/release-(.*)/)?.[1] || branch;
